import { useMemo } from 'react';

import { Workspace } from './WorkspaceContext';
import { TENANT_WORKSPACE_PREFIX } from './utils';
import { useUserTenantPreferences } from 'kineticUtils/hooks';

export const useUserWorkspaces = () => {
  const { data, ...rest } = useUserTenantPreferences<Workspace>();

  const userWorkspaces: Workspace[] = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter((pref) => pref.key.includes(TENANT_WORKSPACE_PREFIX))
      .map(({ value }) => value as Workspace);
  }, [data]);

  return {
    userWorkspaces,
    ...rest,
  };
};
